import { Route } from 'react-router';
import { ExecutorWiresPage } from '../ExecutorWiresPage';
import { getExecutorWiresPath } from '../path/path';
import { getExecutorWireDetailsPath } from '../_ExecutorWireDetailsPage/path/path';
import { ExecutorWireDetailsPage } from '../_ExecutorWireDetailsPage/ExecutorWireDetailsPage';

export const ExecutorRoutes = [
  <Route key={getExecutorWiresPath()} path={getExecutorWiresPath()} element={<ExecutorWiresPage />} />,
  <Route
    key={getExecutorWireDetailsPath()}
    path={getExecutorWireDetailsPath()}
    element={<ExecutorWireDetailsPage />}
  />,
];
